(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('VisualizacaoRelatorio', VisualizacaoRelatorio);

  function VisualizacaoRelatorio($state, $rootScope, GlosaService, VisualizacaoService) {

    var vm = this;

    $rootScope.$state = $state; // necessario para exibir o nome da aba selecionada

    vm.init = init;
    vm.getRelatorioCorrente = getRelatorioCorrente;
    vm.montaAbasVisualizacao = montaAbasVisualizacao;
    vm.voltarTelaFiltro = voltarTelaFiltro;

    vm.init();

    function init() {

      // viewMode default
      $rootScope.viewMode = 'cards';

      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;

      if (vm.promotorSelecionado && vm.relDkSelecionado) {
        vm.montaAbasVisualizacao();
        vm.getRelatorioCorrente();
      }

    }

    function montaAbasVisualizacao() {
      VisualizacaoService.getAbasVisualizacao(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(function (data) {

        vm.tabs = data;

        // aba selecionada por default
        vm.tabSelected = vm.tabs[0];
      });
    }

    function getRelatorioCorrente() {
      GlosaService.getRelatorioCorrente(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(function (data) {
        vm.relatorioGlosa = data;
      });
    }

    function voltarTelaFiltro() {
      $state.go('validoEnviados', {
        periodoSelecionado: $state.params.periodoSelecionado,
        nomeOrgaoFiltrado: $state.params.nomeOrgaoFiltrado,
        promotorSelecionado: $state.params.promotorSelecionado,
        referer: 'botaoVoltar',
        somenteEnviados: true,
        situacaoSelecionada: $state.params.situacaoSelecionada
      });
    }
  }

})();
